import { Component, effect, inject, Input, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { MeStore } from '../auth.me.store';

@Component({
  selector: 'app-login',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
@if (this.meStore.isAuthenticated() === false) {
    <h1>Login</h1>
    <br>Your todos are accessible only to your account and in order to manage them you need to login.
    <h3>You can login with:</h3>
    <ul>
    @for (item of this.providerNames.keys(); track item) {
      <li><a [href]="this.GetUrl(item)" [rel]="this.autoLogin ? 'noreferrer' : null"> {{ this.providerNames.get(item) }}</a></li>
    }
    </ul>
}    
  `,
})
export class LoginComponent  {

  meStore = inject(MeStore);
  router = inject(Router);
  @Input() autoLogin = false;
  @Input() post_login_redirect_uri = "app/todo";
  
  public providerNames = new Map<string, string>([
    ['aad', 'Microsoft'],
    ['google', 'Google'],
  ]);
  
  GetUrl(idp: string) {
    return `/.auth/login/${idp}?access_type=offline&post_login_redirect_uri=` + encodeURIComponent(this.router.url);
  }

  constructor() {
    effect(() => {
      const zumo = this.meStore.zumo()
      if (zumo)
        return;
      
      if (this.meStore.isAuthenticated()) {
        const route = this.router.routerState.root;
        if (route.snapshot.root.fragment) {
          const hash = route.snapshot.root.fragment;
          this.meStore.setZumoFromTokenFragment(hash);
        } else if (this.autoLogin) {
          // This sends the referer
          //window.location.href = this.GetUrl(this.meStore.me()!.providerName);
          const link = document.createElement('a');
          link.href = this.GetUrl(this.meStore.me()!.providerName);
          link.rel = 'noreferrer'; // prevents Referer from being sent
          document.body.appendChild(link);
          link.click();
        }

        this.router.navigateByUrl(this.post_login_redirect_uri).catch(() => {
          console.error('Navigation to redirect URI failed.');
        });
      }
    });
  }
}
